import { Component, OnInit, HostListener, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { SpinnerService } from 'src/app/services/spinner.service';
import { setConfigTable, basicAlert, timerOut, alertaConfirmacion } from 'src/app/shared/utils';
import { Router } from '@angular/router';
import { objProveedorFrm } from 'src/app/modulos/archivos/proveedor/nuevoproveedor/objConfiguracionProveedor.model'
import { BuscarService } from 'src/app/services/buscar.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { ProveedorService } from 'src/app/services/proveedor.service'
import { ModalBusquedaProveedorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proveedor/modal-busqueda-proveedor.component';
import { Proveedor } from 'src/app/models/pproveedor.model';
//
import { ClienteService } from 'src/app/services/cliente.service'
import { CondicionPagoService } from 'src/app/services/condicion-pago.service'
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { bancoService } from 'src/app/services/bancos.service'
import { MonedaService } from 'src/app/services/moneda.service'
import { ImportarSunatComponent } from 'src/app/shared/modals/importar-sunat/importar-sunat.component';
import { ClienteClase } from "src/app/models/ClienteClase.model";
import { CondicionesPago } from 'src/app/models/CondicionesPago.model';
import { Contacto } from 'src/app/models/Contacto.model';
import { ClienteDirecciones } from 'src/app/models/ClienteDirecciones.model';
import { ClienteEspecificaciones } from 'src/app/models/ClienteEspecificaciones.model';
import { ClienteBancos } from 'src/app/models/ClienteBancos.model';
import { ContactoService } from 'src/app/services/contacto.service'
import { RecursosService } from 'src/app/services/recursos.service';
import { ContactoFrmComponent } from 'src/app/shared/modals/contacto-frm/contacto-frm.component';
import { CpagoComprasService } from 'src/app/services/cpago-compras.service';
import { DataService } from 'src/app/services/dataService.service';
import { MdIcUbigeoEdtComponent } from 'src/app/shared/modals/md-ic-ubigeo-edt/md-ic-ubigeo-edt.component';
import { StorageService } from 'src/app/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { NuevoProveedorComponent } from './nuevo-proveedor/nuevo-proveedor.component';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ModificarProveedorComponent } from './modificar-proveedor/modificar-proveedor.component';

@Component({
  selector: 'app-md-proveedor-nuevo',
  templateUrl: './md-proveedor-nuevo.component.html',
  styleUrls: ['./md-proveedor-nuevo.component.css']
})
export class MdProveedorNuevoComponent implements OnInit {

  @Input() proveedores: [];
  position: number = 1;
  index: number = 0;
  disabledInterlocutor: boolean = false;
  buscar_codcli = '';
  buscar_razonc = '';
  vista: number = 1;
  public buscarLimpiarBoton: string = 'buscar';

  //dtTrigger: Subject<null> = new Subject();
  //dtOptions: any = {};

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  constructor(
    private modalService: NgbModal,
     private spinnerService: SpinnerService,
     private router: Router,
     private clienteService: ClienteService,
     private proveedorService: ProveedorService,
     private _buscarService: BuscarService,
     private CondicionPagoService: CondicionPagoService,
     private interlocutorService: InterlocutorService,
     private bancoService: bancoService,
     private MonedaService: MonedaService,
     private VendedorService: VendedorService,
     private contactoService: ContactoService,
     private recursosService: RecursosService,
     private cpagoComprasService: CpagoComprasService,
     public dataService: DataService,
     private toastr: ToastrService,
     private modalService2: NgbActiveModal,

     ) { };


  ngOnInit(): void {
    //console.log('Modal')
    //console.log(this.proveedores)

    /*timerOut(10).then((value: any) => {
      if (value) { this.codArticuloInput.nativeElement.focus(); }
    });*/
    this.spinnerService.activarLoading(true);

    //this.dtOptions = setConfigTableModalBusqueda(false);
    this.position = 0;
    //this.index = this.proveedores.length - 1;
    setTimeout(() => {
      //this.dtTrigger.next();
      this.spinnerService.activarLoading(false);
    }, 800);


  }

  // cancelar(): void {
  //   this.modalService.dismiss('canceling');
  // }
  onKeyEnterCodInterlocutor(e: any) {
    this.onBlurCodInterlocutor(this.buscar_codcli);
  }
  onBlurCodInterlocutor(codcli: string) {
    if (codcli != null || codcli != '') {
      this.spinnerService.activarLoading(true);
      this.getByCodInterlocutor(codcli,1);
    }
  }

  getByCodInterlocutor(codcli: string,tipo: number) {
    this.spinnerService.activarLoading(true);
    this.proveedorService.obtenerProveedor(codcli, null).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.dataService.vista = 1;
      this.dataService.tipo = 'proveedor';
      console.log("Datos a Modificar");
      console.log(response);
      this.disabledInterlocutor = true;
      this.buscarLimpiarBoton = 'borrar';
    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err);
      if (err.status == 404) {
        basicAlert('Proveedor no encontrado', 'warning', 'Aceptar');
      }
      setTimeout(() => {
      }, 350);
    });
  }

  onKeyEnterInterlocutorCodigo(e) {
    this.openModalInterlocutorCodigo();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }
  onKeyEnterInterlocutor(e) {
    this.openModalInterlocutor();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  openModalInterlocutorCodigo() {

    let codcli: string = this.buscar_codcli + "%";
    let razonc: string = this.buscar_razonc + "%";
    let nombres: string = this.buscar_razonc + "%";
    let dident: string = '';
    let soloactivos: boolean = false;
    let limit: number = 350;
    let offset: number = 0;


    // if (this.buscar_razonc.length > 0) {
      this.spinnerService.activarLoading(true);
      console.log(razonc);
     // this.proveedorService.buscarProveedor(codcli, razonc, dident, limit, offset, false)
     this.proveedorService.obtenerProveedorV2(codcli,razonc,false).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
        this.proveedores = response.body;
      }, err => {
        this.proveedores = []
        if (err.status == 404) {
          basicAlert('No se encontró la lista de proveedores.', 'warning', 'Aceptar', null, null);
        }
        this.spinnerService.activarLoading(false);
      });
    // } else {
    //   basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar', null, null);
    //   return;
    // }
  }
  openModalInterlocutor() {

    let codcli: string = this.buscar_codcli + "%";
    let razonc: string = this.buscar_razonc + "%";
    let nombres: string = this.buscar_razonc + "%";
    let dident: string = '';
    let soloactivos: boolean = false;
    let limit: number = 350;
    let offset: number = 0;


    // if (this.buscar_razonc.length > 0) {
      this.spinnerService.activarLoading(true);
      console.log(razonc);
      this.proveedorService.obtenerProveedorV2(codcli,razonc,false).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        this.proveedores = response.body;
      }, err => {
        this.proveedores = []
        if (err.status == 404) {
          basicAlert('No se encontró la lista de proveedores.', 'warning', 'Aceptar', null, null);
        }
        this.spinnerService.activarLoading(false);
      });
    // } else {
    //   basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar', null, null);
    //   return;
    // }
  }
  verInsertar(){
    const referenciaModal = this.modalService.open(NuevoProveedorComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    // referenciaModal.result.then((data) => {
    //   console.log(" data devuelta");
    //   console.log(data);
    // }, (reason) => {
    //   console.log(reason);
    // });
  }

  abrirModificar(data) {
    const referenciaModal = this.modalService.open(ModificarProveedorComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    referenciaModal.componentInstance.codpro = data.codpro;
    // referenciaModal.componentInstance.codart = data.codart;
    referenciaModal.result.then((data) => {
      console.log("data devuelta",data);
       if(data){
         this.openModalInterlocutor();
       }
    }, (reason) => {
      console.log(reason);
  });
  }

  itemtemp
  onClick(data: any): void {
    this.itemtemp = data;
  }
  cerrar(){
    this.modalService2.dismiss('canceling');
  }
  onNexFocus(tipo: string){

  }

}
